import Ajv from "ajv";
import draft04 from "ajv/lib/refs/json-schema-draft-04.json";

const ajv = new Ajv({ schemaId: "auto" });
ajv.addMetaSchema(draft04);

export const validateJson = (data: unknown, schema: object) => {
    const validator = ajv.compile(schema);
    return validator(data);
};